/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';

function trackComponentEvent(eventName, props) {
  if (typeof window !== 'undefined' && window && window.bluemixAnalytics) {
    try {
      window.bluemixAnalytics.onPageContextSet(function (pageContext) {
        var _ref = pageContext || {},
          parentPageCategory = _ref.category,
          parentPageName = _ref.name,
          productId = _ref.productId,
          _ref$productTitle = _ref.productTitle,
          productTitle = _ref$productTitle === void 0 ? 'IBM Cloud Platform' : _ref$productTitle;
        var allProps = _objectSpread2(_objectSpread2({}, props), {}, {
          productId: productId,
          productTitle: productTitle,
          parentPageCategory: parentPageCategory,
          parentPageName: parentPageName
        });
        window.bluemixAnalytics.trackEvent(eventName, allProps);
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("The following error occured: ".concat(error));
    }
  }
}

export { trackComponentEvent as default };
